import { render, staticRenderFns } from "./sizeList.vue?vue&type=template&id=001d0098&scoped=true"
import script from "./sizeList.vue?vue&type=script&lang=js"
export * from "./sizeList.vue?vue&type=script&lang=js"
import style0 from "./sizeList.vue?vue&type=style&index=0&id=001d0098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d0098",
  null
  
)

export default component.exports